// extracted by mini-css-extract-plugin
export default {"spaceBetween":"inputSafetyLightingEquipment_spaceBetween__UVkoh","block":"inputSafetyLightingEquipment_block__fxfLX"};